import React, { useContext, useEffect, useState } from 'react'

import { KycWrapper } from 'shared/components/modals/KycSharedModal/KycModal'

import SspContext from '../../../../contexts/SspContext'
import CardOverview from './CardOverview/CardOverview'
import DepositOverview from './DepositOverview/DepositOverview'

import './Overview.scss'
import { Transactions } from 'selfServicePortal/components'

const Overview = () => {
	const { loading, isCard } = useContext(SspContext)

	const [overview, setOverview] = useState(<></>)

	useEffect(() => {
		if (isCard?.isCard) {
			setOverview(<CardOverview />)
		} else {
			setOverview(<DepositOverview />)
		}
	}, [isCard])

	return (
		<>
			{loading ? (
				<div id="circle-spinner"></div>
			) : (
				<>
					<KycWrapper />
					<>{overview}</>
					<Transactions />
				</>
			)}
		</>
	)
}
export default Overview
